export const capitalizeFirstCharacter = (stringToCapitalize: string): string =>
    stringToCapitalize.charAt(0).toUpperCase() + stringToCapitalize.slice(1);
